import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";

/**
 *  Service qui retourne une liste des mois de l'année
 */
@Injectable()
export class MoisService {
  public h_mois;

  /**
   * Constructeur
   */
  constructor(public s_appsettings: AppSettingsService) {
    this.h_mois = [
      {
        numero: 1,
        libelle: this.s_appsettings.proc_getTraduction("mois.janvier")
      },
      {
        numero: 2,
        libelle: this.s_appsettings.proc_getTraduction("mois.fevrier")
      },
      {
        numero: 3,
        libelle: this.s_appsettings.proc_getTraduction("mois.mars")
      },
      {
        numero: 4,
        libelle: this.s_appsettings.proc_getTraduction("mois.avril")
      },
      { numero: 5, libelle: this.s_appsettings.proc_getTraduction("mois.mai") },
      {
        numero: 6,
        libelle: this.s_appsettings.proc_getTraduction("mois.juin")
      },
      {
        numero: 7,
        libelle: this.s_appsettings.proc_getTraduction("mois.juillet")
      },
      {
        numero: 8,
        libelle: this.s_appsettings.proc_getTraduction("mois.aout")
      },
      {
        numero: 9,
        libelle: this.s_appsettings.proc_getTraduction("mois.septembre")
      },
      {
        numero: 10,
        libelle: this.s_appsettings.proc_getTraduction("mois.octobre")
      },
      {
        numero: 11,
        libelle: this.s_appsettings.proc_getTraduction("mois.novembre")
      },
      {
        numero: 12,
        libelle: this.s_appsettings.proc_getTraduction("mois.decembre")
      }
    ];
  }

  /**
   * Fonction de recuperation de toutes les mois
   */
  public proc_getAll(): any {
    return this.h_mois;
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/mois.service.ts